<template>
  <div v-if="isMounted">
    <LlAppFixedToolBar v-if="isHeaderBarShow">
      <LvTabs
        v-if="tabs"
        :items="tabs.items"
        :value="tabs.selectedTabId"
        :isDisabled="isLoading.content || isLoading.parentApi"
        @input="$_onClickTab($event, 'tab')"
      />
      <WsTextButton001
        v-else-if="preUrl"
        primary
        noPadding
        leadingIcon="icon-arrow-left"
        @click="$_backToPreUrl"
      >
        {{ $t('返回') }}
      </WsTextButton001>
    </LlAppFixedToolBar>
    <LlScrollableWrap
      v-model="position"
      :disabled="scrollDisable"
      @scroll-search="$_scrollGetListData()"
    >
      <LlScrollableBlock v-if="isLoading.parentPage">
        <NormalSkeleton />
      </LlScrollableBlock>
      <LlScrollableBlock v-else :transparent="transparent">
        <LvDataTable
          ref="LvDataTable"
          :title="title"
          :tabs="contentTabs"
          :fetchUrl="fetchUrl"
          :setTitle="setTitle"
          :setParams="setParams"
          :createUrl="createUrl"
          :isCreatable="isCreatable"
          :setFetchUrl="setFetchUrl"
          :setListData="setListData"
          :columnHeader="columnHeader"
          :createScopes="createScopes"
          :isScrollFetch="isScrollFetch"
          :customBtnList="customBtnList"
          :filterFieldTypes="filterFieldTypes"
          :fetchTabAmountUrl="fetchTabAmountUrl"
          :setTabAmountParams="setTabAmountParams"
          :setTabAmountListData="setTabAmountListData"
          :onlyDisplayCollect="onlyDisplayCollect"
          :isFilterFieldTypeChange="isFilterFieldTypeChange"
          @create="$emit('create')"
          @click-btn="$_onClickBtn($event)"
          @click-item="$_onClickItem($event)"
          @click-icon="$_onClickIcon($event)"
          @loading="$_onChangeIsLoading($event)"
          @data-click="$emit('data-click', $event)"
          @click-checkbox="$_onClickCheckbox($event)"
          @click-tab="$_onClickTab($event, 'content-tab')"
          @click-icon-btn="$emit('click-icon-btn', $event)"
          @menu-item-click="$emit('menu-item-click', $event)"
          @click-custom-btn="$emit('click-custom-btn', $event)"
          @filter-state-change="$emit('filter-state-change', $event)"
          @click-icon-nav-drawer="$emit('click-icon-nav-drawer', $event)"
        >
          <template v-slot:titleButton>
            <slot name="titleButton" />
          </template>
          <template v-slot:section="{ isLoading }">
            <slot name="section" :isLoading="isLoading" />
          </template>
          <template v-slot:content="{ listData, isLoading }">
            <slot name="content" :listData="listData" :isLoading="isLoading" />
          </template>
          <template v-slot:item="{ rowItem, columnHeaderItem }">
            <slot name="item" :rowItem="rowItem" :columnHeaderItem="columnHeaderItem" />
          </template>
          <template v-slot:filterBtns="{ filterState }">
            <slot name="filterBtns" :filterState="filterState" />
          </template>
        </LvDataTable>
        <div v-if="isCreatable && _hasScopeCreate && isActive.fixedBtn">
          <RoundButton @click="$_onCreate" />
        </div>
      </LlScrollableBlock>
    </LlScrollableWrap>
  </div>
</template>

<script>
import S_scope from '@/service/api/v1/scope';

export default {
  props: {
    title: {
      type: String,
    },
    fetchUrl: {
      type: String,
    },
    createUrl: {
      type: String,
    },
    createScopes: {
      type: Array,
    },
    tabs: {
      type: Object,
    },
    setListData: {
      type: Function,
    },
    filterFieldTypes: {
      type: Array,
    },
    columnHeader: {
      type: Array,
    },
    setParams: {
      type: Function,
    },
    onlyDisplayCollect: {
      type: Boolean,
      default: false,
    },
    isScrollFetch: {
      type: Boolean,
      default: false,
    },
    contentTabs: {
      type: Object,
    },
    isCreatable: {
      type: Boolean,
      default: false,
    },
    isFilterFieldTypeChange: {
      type: Boolean,
      default: false,
    },
    isHeaderBarShow: {
      type: Boolean,
      default: true,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    setFetchUrl: {
      type: Function,
    },
    scrollDisable: {
      type: Boolean,
      default: false,
    },
    setTitle: {
      type: Function,
    },
    customBtnList: {
      type: Array,
    },
    preUrl: {
      type: String,
    },
    fetchTabAmountUrl: {
      type: String,
    },
    setTabAmountParams: {
      type: Function,
    },
    setTabAmountListData: {
      type: Function,
    },
  },
  data() {
    return {
      position: {
        scrollTop: 0,
        scrollLeft: 0,
        scrollTotalHeight: 0,
        windowTotalHeight: 0,
      },
      window: {
        width: 0,
        height: 0,
      },
      isLoading: {
        content: false,
        filter: false,
        parentApi: false,
        parentPage: false,
      },
      isActive: {
        fixedBtn: false,
      },
      isMounted: false,
    };
  },
  computed: {
    _currentUser() {
      return this.$store.state.stone_auth.currentUser;
    },
    _currentFactoryId() {
      return this.$route.params.factoryId;
    },
    _paginationPrevText() {
      return '<i class="icon-chevron-back" />';
    },
    _paginationNextText() {
      return '<i class="icon-chevron-forward" />';
    },
    _paginationFirstButtonText() {
      return '<i class="icon-chevron-back-start" />';
    },
    _paginationLastButtonText() {
      return '<i class="icon-chevron-forward-end" />';
    },
    _hasScopeCreate() {
      return S_scope.$_isAvailable(this.createScopes);
    },
  },
  watch: {
    position() {
      this.$_fixedButtonVisible();
    },
  },
  async mounted() {
    this.$_handleResize();
    this.$_initQueryAndTab();
    this.isMounted = true;
  },
  created() {
    window.addEventListener('resize', this.$_handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_handleResize);
  },
  methods: {
    $_handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    $_onClickItem($event) {
      this.$emit('click-item', $event);
    },
    $_onClickCheckbox($event) {
      this.$emit('click-checkbox', $event);
    },
    $_onClickBtn($event) {
      this.$emit('click-btn', $event);
    },
    $_onClickTab($event, type) {
      const LvDataTable = this.$refs.LvDataTable;
      if (
        LvDataTable.isLoading.content ||
        LvDataTable.isLoading.filter ||
        LvDataTable.isLoading.parentApi
      )
        return;
      const tabId = type === 'content-tab' ? $event : $event.id;
      const key = type === 'content-tab' ? 'contentTab' : type;
      this.$router.replace({
        query: {
          ...this.$route.query,
          [key]: tabId,
        },
      });
      this.$emit(`click-${type}`, tabId);
    },
    async $_scrollGetListData() {
      if (!this.isScrollFetch) return;
      const { scrollTotalHeight, windowTotalHeight, scrollTop } = this.position;
      const allScrollHeight = scrollTotalHeight - windowTotalHeight;
      const scrollHeight = scrollTop;
      const LvDataTable = this.$refs.LvDataTable;
      if (
        scrollHeight / allScrollHeight > 0.9 &&
        !LvDataTable.isLoading.content &&
        !LvDataTable.isLoading.parentApi
      ) {
        if (LvDataTable.paginate.ingPage < LvDataTable.paginate.lastPage) {
          LvDataTable.paginate.ingPage += 1;
          await this.$_getListData(true);
        }
      }
    },
    $_onClickIcon($event) {
      this.$emit('click-icon', $event);
    },
    $_onChangeIsLoading($event) {
      const { type, value } = $event;
      this.isLoading[type] = value;
    },
    $_initQueryAndTab() {
      const hasTab = this.$_hasTab(this.tabs);
      const hasContentTab = this.$_hasTab(this.contentTabs);
      if (!hasTab && !hasContentTab) return;
      const { tab, contentTab } = this.$route.query;
      const nextQuery = { ...this.$route.query };
      if (hasTab) {
        const selectedTabId = this.$_queryInTabItems(tab, this.tabs?.items)
          ? tab
          : this.tabs?.items[0]?.id;
        this.$emit('init-tab', selectedTabId);
        nextQuery.tab = selectedTabId;
      }
      if (hasContentTab) {
        const selectedContentTabId = this.$_queryInTabItems(contentTab, this.contentTabs?.items)
          ? contentTab
          : this.contentTabs?.items[0]?.id;
        this.$emit('init-content-tab', selectedContentTabId);
        nextQuery.contentTab = selectedContentTabId;
      }
      this.$router.replace({ query: nextQuery });
    },
    $_hasTab(tab) {
      return tab && tab.selectedTabId !== undefined && tab.items && tab.items.length > 0;
    },
    $_queryInTabItems(queryValue, tabItems) {
      if (!queryValue || !tabItems || tabItems.length === 0) return false;
      return tabItems.some(item => item.id === queryValue);
    },
    $_fixedButtonVisible() {
      this.isActive.fixedBtn = this.position.scrollTop > 100;
    },
    async $_getListData(isScroll) {
      await this.$refs.LvDataTable.$_getListData(isScroll);
    },
    $_onChangeDataTableIsLoading(type, value) {
      if (!this.$refs.LvDataTable) return;
      this.$refs.LvDataTable.isLoading[type] = value;
    },
    $_backToPreUrl() {
      if (!this.preUrl) return;
      this.$router.push({
        path: `/factory/${this.$store.state.app.factory.id}/${this.preUrl}`,
        query: this.$route.query,
      });
    },
    $_onCreate() {
      if (this.createUrl) {
        this.$router.push({
          path: this.createUrl,
          query: this.$route.query,
        });
      } else {
        this.$emit('create');
      }
    },
    startLoadingParentPage() {
      this.isLoading.parentPage = true;
    },
    stopLoadingParentPage() {
      this.isLoading.parentPage = false;
    },
  },
};
</script>
